export default __webpack_public_path__ + "static/logo-9383af6d89f27b2af2f1ecbbe00a503d.png";